import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { themeOverrides as r } from "../../constants/themeConfig.js";
import { vCopyVueucStylesToShadowDom as n } from "../../utils/vCopyVueucStylesToShadowDom.js";
import m from "./floatWindowContent.vue.js";
import { vShadowPropertyPolyfill as d } from "../../utils/vShadowPropertyPolyfill.js";
import { defineComponent as c, withDirectives as p, openBlock as f, createBlock as s, withCtx as u, createVNode as y } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as h } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as t } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import g from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import v from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
const V = /* @__PURE__ */ c({
  __name: "floatWindow.ce",
  props: {
    list: { default: () => [], type: Array },
    activeKey: { default: "", type: String },
    initialX: { default: 20, type: Number },
    initialY: { default: 20, type: Number },
    draggable: { type: Boolean, default: !0 }
  },
  emits: ["click", "updateActiveKey"],
  setup(C, { emit: a }) {
    const i = a, o = h(), l = (e) => {
      i("updateActiveKey", e.key), i("click", e), console.log("FloatWindowContent handleClick", e, e.key);
    };
    return (e, w) => p((f(), s(t(k), {
      "style-mount-target": t(o),
      locale: t(g),
      "date-locale": t(v),
      "theme-overrides": t(r)
    }, {
      default: u(() => [
        y(m, {
          list: e.list,
          "active-key": e.activeKey,
          "initial-x": e.initialX,
          "initial-y": e.initialY,
          draggable: e.draggable,
          onClick: l
        }, null, 8, ["list", "active-key", "initial-x", "initial-y", "draggable"])
      ]),
      _: 1
    }, 8, ["style-mount-target", "locale", "date-locale", "theme-overrides"])), [
      [t(n), t(o)],
      [t(d), t(o)]
    ]);
  }
});
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/float-window/floatWindow.ce.vue2.js
// module id = 1245
// module chunks = 41